import { render, staticRenderFns } from "./error_session.vue?vue&type=template&id=480ae31d&scoped=true&"
import script from "./error_session.vue?vue&type=script&lang=js&"
export * from "./error_session.vue?vue&type=script&lang=js&"
import style0 from "./error_session.vue?vue&type=style&index=0&id=480ae31d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ae31d",
  null
  
)

export default component.exports